// src/mixins/layout.mixin.js
export default {
    data() {
      return {
        isHoveringLogo: false,
        isFullscreen: false,
        isSidebarOpen: false,
        mainStyle: { 'margin-left': '0' },
        finishedLoadingComponents: false,
      };
    },
    methods: {
      loadApp() {
        const pre = document.getElementById('pre-render-app_spinner');
        if (pre) pre.remove();
        this.finishedLoadingComponents = true;
      },
      showSideBar() {
        const margin = window.innerWidth <= 991 ? "0" : "auto";
        this.isSidebarOpen = true;
        this.mainStyle = { transition: '0.5s', 'margin-left': margin };
      },
      hideSideBar() {
        this.isSidebarOpen = false;
        this.mainStyle = { transition: '0.5s', 'margin-left': '0' };
      },
      toggleFullscreen(state) {
        this.isFullscreen = state;
        this.$root.$emit('bv::toggle::collapse', 'sidebar');
        this.hideSideBar();
      },
    },
  };
  